export function paymentCheckoutUrl(value: string | undefined): string | undefined {
  if (!value) return undefined;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : undefined;
  } catch {
    return undefined;
  }
}

export function redirectToPaymentCheckout(url: string): void {
  // Same-tab navigation also works after an asynchronous order request.
  window.location.assign(url);
}
